import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { IFornecedorDTO, IIndicadorInstrucaoEstadualCleanDTO, ITipoPapelCleanDTO } from '../../../../models/happy-code-api.model';
import { useIndicadorInstrucaoEstadualService } from '../../../../services/indicador-instrucao-estadual.service';
import { useTipoPapelService } from '../../../../services/tipo-papel.service';
import { useFornecedorService } from '../../../../services/fornecedor.service';
import { useNotificationService } from '../../../../services/notification.service';

export default function useSaveAndFetchDataFornecedor() {
	const [fornecedor, setFornecedor] = useState<IFornecedorDTO>();
	const { idFornecedor } = useParams<any>();
	const [tipoPapel, setTipoPapel] = useState<ITipoPapelCleanDTO[]>();
	const [indicadorInscricaoEstadual, setIndicadorInscricaoEstadual] = useState<IIndicadorInstrucaoEstadualCleanDTO[]>();

	const { setIsGlobalLoading, unidade } = useGlobalContext();
	const tipoPapelService = useTipoPapelService();
	const indicadorInscricaoEstadualService = useIndicadorInstrucaoEstadualService();
	const fornecedorService = useFornecedorService();
	const notification = useNotificationService();

	const history = useHistory();

	const addUnidadeInFornecedor = (fornecedor: IFornecedorDTO) => {
		return { ...fornecedor, unidade: unidade };
	};

	const validateFields = () => {
		if (!fornecedor?.tipoPessoa) {
			notification({
				description: 'Preencha o tipo de pessoa',
				type: 'warning',
				message: 'Aviso',
			});
			return false;
		}
		if (fornecedor.tipoPessoa === 'Jurídica' && !fornecedor?.nomeFantasia) {
			notification({
				description: 'Preencha o nome fantasia',
				type: 'warning',
				message: 'Aviso',
			});
			return false;
		}
		if (!fornecedor?.tipoPapel) {
			notification({
				description: 'Preencha o tipo de papel',
				type: 'warning',
				message: 'Aviso',
			});
			return false;
		}
		if(!fornecedor.nomeFantasia){
			notification({
				description: 'Preencha o nome fantasia',
				type: 'warning',
				message: 'Aviso',
			});
			return false;
		}
		if(!fornecedor.documento){
			notification({
				description: 'Preencha o CPF/CNPJ',
				type: 'warning',
				message: 'Aviso',
			});
			return false;
		}
		return true;
	};

	const handleSaveOrEdit = async () => {
		const validate = validateFields();
		if (!validate) return;
		setIsGlobalLoading(true);
		if (!idFornecedor) {
			await fornecedorService
				.createCustom(addUnidadeInFornecedor(fornecedor))
				.then(() => {
					notification({
						description: 'Fornecedor cadastrado com sucesso!',
						type: 'success',
						message: 'Sucesso',
					});
				})
				.finally(() => {
					setIsGlobalLoading(false);
					history.push('/contas-a-pagar/cadastro-despesas/');
				});
		} else {
			await fornecedorService
				.patchCustom(idFornecedor, fornecedor)
				.then(() => {
					notification({
						description: 'Fornecedor alterado com sucesso!',
						type: 'success',
						message: 'Sucesso',
					});
				})
				.finally(() => {
					setIsGlobalLoading(false);
					history.push('/contas-a-pagar/cadastro-despesas/');
				});
		}
	};

	const findTipoPapel = async () => {
		await tipoPapelService.findCleanList().then(({ data }) => setTipoPapel(data));
	};
	const findIndicadorInscricaoEstadual = async () => {
		await indicadorInscricaoEstadualService.findCleanList().then(({ data }) => setIndicadorInscricaoEstadual(data));
	};

	const findFornecedorById = async () => {
		await fornecedorService.findById({ id: idFornecedor }).then(({ data }) => setFornecedor(data));
	};
	useEffect(() => {
		setIsGlobalLoading(true);
		Promise.all([findTipoPapel(), findIndicadorInscricaoEstadual()])
			.then(() => {
				if (idFornecedor) findFornecedorById();
			})
			.finally(() => setIsGlobalLoading(false));
	}, [idFornecedor]);

	return {
		fornecedor,
		setFornecedor,
		tipoPapel,
		indicadorInscricaoEstadual,
		handleSaveOrEdit,
	};
}
